module.exports = __webpack_public_path__ + "static/media/S1_00044.af2d64b0.jpg";